module.exports = __webpack_public_path__ + "static/media/me3_yellow_WarningIcon.ef63fe6b.svg";